import { useStorage } from "@vueuse/core";

/**
 * État persistant de la sidebar de paramétrage :
 * - `collapsed` : rail d'icônes replié sur desktop
 * - `openSections` : ouvert/fermé mémorisé par clé de section
 */
export const useSidebarStore = () => {
  const collapsed = useStorage("sidebar:collapsed", false);
  const openSections = useStorage<Record<string, boolean>>(
    "sidebar:open-sections",
    {},
  );

  return { collapsed, openSections };
};
